function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect, useCallback } from 'react';
export default function LanguageSelector(_ref) {
  var appProps = _ref.appProps;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    openLocales = _useState2[0],
    setOpenLocales = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    hover = _useState4[0],
    setHover = _useState4[1];
  var currentLanguage = appProps.languages.filter(function (l) {
    return l.code === appProps.currentLocale;
  })[0];
  useEffect(function () {
    document.addEventListener("keydown", escFunction, false);
    return function () {
      document.removeEventListener("keydown", escFunction, false);
    };
  }, []);
  var escFunction = useCallback(function (event) {
    if (event.key === "Escape") {
      setOpenLocales(false);
    }
  }, []);
  function changeLocale(locale) {
    var path = "".concat(appProps.changeLocalePath, "?locale=").concat(locale, "&redirect_url=").concat(window.location.pathname + window.location.search);
    if (appProps.currentLocale) {
      path += "&prev_locale=".concat(appProps.currentLocale);
    }
    if (appProps.entityWithTranslatableId) {
      path += "&entity_id=".concat(appProps.entityWithTranslatableId, "&entity_type=").concat(appProps.entityWithTranslatableSlugType);
    }
    if (appProps.entityBlogArchiveSlug) {
      path += "&blog_archive_slug=".concat(appProps.entityBlogArchiveSlug);
    }
    if (appProps.entityBlogCategorySlug) {
      path += "&blog_category_slug=".concat(appProps.entityBlogCategorySlug);
    }
    window.location.href = path;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "language-switcher"
  }, /*#__PURE__*/React.createElement("div", {
    className: "language-switcher-select",
    style: {
      position: 'relative'
    }
  }, currentLanguage.icon && /*#__PURE__*/React.createElement("div", {
    className: "current-lang pointer",
    onClick: function onClick() {
      return setOpenLocales(function (prevState) {
        return !prevState;
      });
    }
  }, currentLanguage && /*#__PURE__*/React.createElement("img", {
    src: currentLanguage.icon,
    style: {
      'maxHeight': 30
    }
  })), openLocales && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "open-locales-box-overlay",
    onClick: function onClick() {
      return setOpenLocales(false);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "open-locales-box flex-box flex-column"
  }, appProps.languages.map(function (l, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      style: _objectSpread(_objectSpread({}, appProps.currentLocale === l.code ? {
        color: appProps.frontendStyles.general.colorScheme
      } : {}), hover === l.code ? {
        color: appProps.frontendStyles.general.colorScheme
      } : {}),
      className: "locale-box-item pointer",
      onMouseEnter: function onMouseEnter() {
        return setHover(l.code);
      },
      onMouseLeave: function onMouseLeave() {
        return setHover(false);
      },
      onClick: function onClick() {
        return changeLocale(l.code);
      }
    }, l.presentation);
  }))))));
}